/* eslint-disable import/no-anonymous-default-export */

export default (newIndividualInvestment = [], action) => {
  switch (action.type) {
    case "NEW_INDIVIDUAL_INVESTMENTS":
      return action.payload;
    case "APPROVE_INDIVIDUAL_NEW_INVESTMENT":
      return newIndividualInvestment.filter(
        (data) => data._id !== action.payload
      );
    case "DELETE_INDIVIDUAL_NEW_INVESTMENT":
      return newIndividualInvestment.filter(
        (data) => data._id !== action.payload
      );
    default:
      return newIndividualInvestment;
  }
};
